import { getTeamsSearch } from "@aura-frontend/omnibus-az-client";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { addOrgPrefix } from "@/lib/utils";

export function useRosterPlayers({
  organizationId,
  rosterId,
  enabled = true,
}: {
  organizationId: string | undefined;
  rosterId: string | undefined;
  enabled?: boolean;
}) {
  const { data, isLoading } = useQuery({
    queryKey: ["getRosterPlayers", organizationId, rosterId],
    queryFn: async () => {
      if (!organizationId || !rosterId) return null;

      const { data } = await getTeamsSearch({
        query: {
          visibilityGroup: addOrgPrefix(organizationId),
          externalId: rosterId,
        },
        throwOnError: true,
      });

      return data;
    },
    enabled: enabled && !!organizationId && !!rosterId,
  });

  const playerExternalIds = useMemo(() => {
    const roster = data?.teams?.[0];

    if (!roster?.unofficial_members) return [];

    return roster.unofficial_members
      .map((m) => m.externalId)
      .filter((id): id is string => !!id);
  }, [data]);

  return { playerExternalIds, isLoading };
}
